import React, { useContext, useCallback } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { PATH_HOME } from '../../system/constants';
import { AppContext } from '../contexts';
import { BASE_URL } from '../constants';
import _get from 'lodash/get';
import AuthHandlerLayout from '../../authHandler/AuthHandlerLayout';
import BlockUserLayout from '../../auth/BlockUserLayout';

const AfitdPrivateRouteSuperUser = props => {
    const appContext = useContext(AppContext);
    // const auth = _get(appContext, 'auth');
    const { authUser, emailVerified, authTypeEmail, currentUser } = appContext;

    const { component: RouteComponent, children, type: routeType, ...rest } = props;

    const getRouteRender = useCallback(
        routeProps => {
            const redirectPathname = _get(routeProps, 'location.pathname', `${BASE_URL}/`);

            if (authUser) {
                if (emailVerified || !authTypeEmail) {
                    if (currentUser) {
                        const isSuperUser = currentUser?.superUser;

                        // if (isSuperUser || process.env.REACT_APP_ENV !== 'PROD') {
                        if (isSuperUser) {
                            return children;
                        } else {
                            return <BlockUserLayout />;
                        }
                    } else {
                        return null;
                    }
                } else {
                    // pre-verified. Redirect to 'verify email' page.
                    return <AuthHandlerLayout showVerificationEmailSent />;
                }
            } else {
                // set the original path in the router location state with a flag telling it to show the login dialog
                return <Redirect to={{ pathname: `${BASE_URL}${PATH_HOME}`, state: { redirectPathname, isPromptLogin: true }, push: true }} />;
            }
        },
        [authUser, currentUser, children, emailVerified, authTypeEmail],
    );

    return <Route {...rest} render={getRouteRender} />;
};

export default AfitdPrivateRouteSuperUser;
